"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var kb_utilities_1 = require("../kb.utilities");
function deserializeMetaFields(fieldDtos) {
    return immutable_1.List(fieldDtos).map(createMetaField);
}
exports.deserializeMetaFields = deserializeMetaFields;
function createMetaField(fieldDto) {
    var metaField = lodash_1.mapValues(fieldDto, function (value, key) {
        if (key === skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE) {
            return skynet_store_utilities_1.deserializeMultilingual(value);
        }
        else {
            return skynet_store_utilities_1.deserializeIfMultilingual(value);
        }
    });
    return kb_utilities_1.makeValueObject(metaField, function (first, other) {
        return kb_utilities_1.toLower(first.metaFieldId.systemName) ===
            kb_utilities_1.toLower(other.metaFieldId.systemName) &&
            kb_utilities_1.toLower(first.metaFieldId.metaCategoryId.systemName) ===
                kb_utilities_1.toLower(other.metaFieldId.metaCategoryId.systemName);
    }, function (obj) {
        return immutable_1.hash(obj.metaFieldId.systemName) * 31 +
            immutable_1.hash(obj.metaFieldId.metaCategoryId.systemName);
    });
}
exports.createMetaField = createMetaField;
function metaFieldToSavable(metaField) {
    return {
        group: metaField.metaFieldId.groupId,
        systemName: metaField.metaFieldId.systemName,
        displayName: skynet_store_utilities_1.notNil(metaField.displayName) ? metaField.displayName : '',
        isSystemField: metaField.isSystemField,
        isKeyField: metaField.isKeyField,
        isName: metaField.isName,
        columnName: metaField.columnName,
        displayNameMultilingual: skynet_store_utilities_1.notNil(metaField.displayNameMultilingual)
            ? skynet_store_utilities_1.serializeMultilingualString(metaField.displayNameMultilingual)
            : undefined,
        // TODO: implement in backend
        pluralName: undefined,
        description: undefined,
        isMultiline: metaField.isMultiline,
        metaFieldType: metaField.metaFieldType,
        metaCategoryId: metaField.classifierMetaCategoryId ||
            metaField.lookupMetaCategoryId ||
            metaField.subEntityMetaCategoryId ||
            metaField.parentMetaCategoryId ||
            metaField.mainEntityCategoryId ||
            metaField.documentMetaCategoryId ||
            metaField.workflowStateMetaCategoryId,
        isImage: metaField.isImage,
        hintKey: metaField.hintKey,
        maxLength: metaField.maxLength,
        fieldPrefix: metaField.fieldPrefix,
        isSearchableField: metaField.isSearchableField,
        isTransient: metaField.isTransient,
        sortInfo: metaField.sortInfo,
    };
}
exports.metaFieldToSavable = metaFieldToSavable;
//# sourceMappingURL=field.serializer.js.map